
import {
  computed, defineComponent,
} from '@vue/composition-api';
import {
  hasExtensionManagerModel,
} from '@/lib/api/extension.service';

const BuildDate = process.env.VUE_APP_BUILD_DATE as string;
const GitHash = process.env.VUE_APP_GIT_HASH as string;

export default defineComponent({
  name: 'App',

  setup() {
    const hasExtensionManagerModelComputed = computed(() => hasExtensionManagerModel());
    const buildDate = computed(() => BuildDate);
    const gitRevision = computed(() => GitHash.slice(0, 7));
    const gitRevisionUrl = computed(() => `https://github.com/KitwareMedical/slicer-extensions-webapp/commit/${GitHash}`);

    return {
      hasExtensionManagerModel: hasExtensionManagerModelComputed,
      buildDate,
      gitRevision,
      gitRevisionUrl,
    };
  },
});

